import { cn } from "@/lib/utils";

export const SectionHeader = ({
  title,
  description,
  actions,
  className,
  testId,
}) => (
  <div
    className={cn("flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between mb-4 min-w-0", className)}
    data-testid={testId}
  >
    <div className="min-w-0">
      <h2 className="section-title">
        {title}
      </h2>
      {description ? (
        <p className="section-description">{description}</p>
      ) : null}
    </div>
    {actions ? <div className="flex flex-wrap items-center gap-2 shrink-0">{actions}</div> : null}
  </div>
);
